module.exports = __webpack_public_path__ + "media/Intro_video.7fd59061.mp4";